import {
  APIProvider,
  InfoWindow,
  Map,
  Marker,
} from "@vis.gl/react-google-maps";
import PlaceInfo from "./components/PlaceInfo";
import { GOOGLE_API_KEY } from "constants/common";
import useViewPlacesOnMap from "hooks/useViewPlacesOnMap";

export default function ViewPlacesOnMap() {
  const {
    currentLocation,
    handleClosePlace,
    handleShowPlace,
    handleZoomChanged,
    handleReload,
    loading,
    places,
    viewPlace,
    zoomLevel,
  } = useViewPlacesOnMap();

  return (
    <div
      className="w-full h-full grow bg-white rounded-lg p-6 flex"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      {loading ? (
        <div className="w-full h-full flex justify-center items-center p-10">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
        </div>
      ) : (
        <div className="grow">
          <APIProvider apiKey={GOOGLE_API_KEY}>
            <Map
              defaultZoom={14}
              defaultCenter={currentLocation}
              onZoomChanged={handleZoomChanged}
            >
              {places.map((place) => (
                <Marker
                  key={place.id}
                  position={{ lat: place.latitude, lng: place.longitude }}
                  onClick={() => handleShowPlace(place)}
                />
              ))}
              {viewPlace?.id && (
                <InfoWindow
                  key={`${viewPlace.id}`}
                  position={{
                    lat: viewPlace.latitude + zoomLevel,
                    lng: viewPlace.longitude,
                  }}
                  headerDisabled
                  onCloseClick={handleClosePlace}
                >
                  <PlaceInfo place={viewPlace} handleReload={handleReload} />
                </InfoWindow>
              )}
            </Map>
          </APIProvider>
        </div>
      )}
    </div>
  );
}
